import { Formik } from "formik";
import React from "react";
import {
    validateEmailFields,
    validateEmailsFields,
} from "src/utils/formValidations";
import {
    defaultLocation,
    SETTINGS_LOCATIONS_FORM_INITIAL_VALUES,
} from "../RetailerSettingsConstants";
import Api from "src/data/api";
import { useDispatch } from "react-redux";
import { ERROR_MESSAGES, SETTINGS_MESSAGES } from "src/constants/messages";
import { NOTIFICATION_TYPES } from "src/constants/notificationTypes";
import { NOTIFICATION_HEADERS } from "src/constants/notificationHeaders";
import { showNotification } from "src/redux/notificationActions";

const updateLocationSettings = async (data, endpoint) => {
    await Api.request({
        method: "POST",
        url: endpoint,
        data,
    });
};

const SettingsLocationsFormik = ({
    locationSettings,
    children,
    currentLocation,
    setRefetch,
    userCalendars,
}) => {
    const dispatch = useDispatch();

    return (
        <Formik
            enableReinitialize
            initialValues={{
                ...SETTINGS_LOCATIONS_FORM_INITIAL_VALUES,
                ...locationSettings,
            }}
            validate={(values) => {
                const emailsFields = ["additionalEmails"];
                const emailFields = ["email"];

                return {
                    ...validateEmailsFields(values, emailsFields),
                    ...validateEmailFields(values, emailFields),
                };
            }}
            onSubmit={async (values, { setSubmitting }) => {
                const emails = [
                    values.email,
                    ...values.additionalEmails,
                ].filter((email) => email);

                const phoneNumbers = [
                    values.phoneNumber,
                    ...values.phoneNumbers,
                ].filter((phone) => phone);

                const data = {
                    locationId: currentLocation.value,
                    emails,
                    phoneNumbers,
                    selectedCalendars: [values.selectedCalendars]
                        .filter((calendarId) => calendarId)
                        .map((calendarId) => ({
                            calendarId,
                            summary: userCalendars.find(
                                (calendar) => calendar.id === calendarId
                            )?.summary || null,
                        })),
                };

                const endpoint =
                    currentLocation.value === defaultLocation.value
                        ? "/retailer/settings/virtual"
                        : `/retailer/settings/location/${currentLocation.value}`;

                try {
                    await updateLocationSettings(data, endpoint);
                    dispatch(
                        showNotification(
                            SETTINGS_MESSAGES.UPDATE_LOCATION_EMAILS_SUCCESS,
                            NOTIFICATION_TYPES.SUCCESS,
                            NOTIFICATION_HEADERS.RETAILER_SETTINGS
                        )
                    );
                } catch (err) {
                    console.log(err);
                    dispatch(
                        showNotification(
                            ERROR_MESSAGES.SOMETHING_WENT_WRONG,
                            NOTIFICATION_TYPES.ERROR,
                            NOTIFICATION_HEADERS.OOPS
                        )
                    );
                } finally {
                    setRefetch((x) => !x);
                    setSubmitting(false);
                }
            }}
        >
            {children}
        </Formik>
    );
};

export default SettingsLocationsFormik;
